import { render } from "./PlansSection.vue?vue&type=template&id=632d8f54&scoped=true"
import script from "./PlansSection.vue?vue&type=script&lang=js"
export * from "./PlansSection.vue?vue&type=script&lang=js"

import "./PlansSection.vue?vue&type=style&index=0&id=632d8f54&scoped=true&lang=css"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632d8f54"]])

export default __exports__